import React, { useContext } from 'react'
import { RequestContext } from '../Contexts/RequestContext'
import { useTranslation } from '@nic/commons'
import { useAssignmentRequest } from '../AssignmentRequests/useAssignmentRequest'
import { HorizontalLayout } from '@nic/ui-comps'
import { Space, Typography } from 'antd'
import { AssignmentRequestTag } from '../AssignmentRequests/AssignmentRequestTag'
import { AssignmentRequestActions } from '../AssignmentRequests/ButtonsAssignmentRequestActions'
import { isRegistrarUserDomain, isRegistryUserDarwinAdmin } from '../User/utils'
import { useAuth } from '@nic/kc-auth'
import { useScopeInfo } from '../Hooks/useScopeInfo'

export function AssignmentRequestContent(props: { labels?: boolean }) {
  const request = useContext(RequestContext)
  const t = useTranslation()
  const { scope } = useScopeInfo()
  const {
    isRegistryAssignedUser,
    isRegistryAssigned,
    registrarStatus,
    isRegistrarAssignedUser, isRegistrarAssigned,
  } = useAssignmentRequest()
  const { keycloak } = useAuth()
  const isDarwinAdmin = keycloak ? isRegistryUserDarwinAdmin(keycloak) : undefined

  const _disableAssignToMeButton = scope === 'registrar' ? isRegistrarAssignedUser || (isRegistrarAssigned && keycloak && isRegistrarUserDomain(keycloak)) : isRegistryAssignedUser || (!isDarwinAdmin && isRegistryAssigned)
  const _disableAssignToUserButton = scope === 'registrar' ? false : !isDarwinAdmin
  const _disableReleaseButton = scope === 'registrar' ? !isRegistrarAssignedUser : !isRegistryAssignedUser
  return (
    <HorizontalLayout
      style={{
        gap: 20,
        justifyContent: 'space-between',
        width: '100%',
        verticalAlign: 'bottom',
      }}
    >
      <div>
        <Space>
          {props.labels && (
            <Space style={{ marginRight: 30 }}>
              <Typography.Text>{t('RegistrarOperator')}:</Typography.Text>
              <div style={{ fontSize: 12, fontWeight: '700' }}>
                <AssignmentRequestTag
                  showIcon
                  scope={'registrar'}
                  status={registrarStatus}
                  name={request.stateReqById.data?.registrarUser?.username}
                  noStyle={request.scope === 'registry'}
                />
              </div>
            </Space>
          )}
          {props.labels && request.scope === 'registry' && (
            <Space>
              <Typography.Text>{t('RegistryOperator')}:</Typography.Text>
              {isRegistryAssignedUser ? (
                <AssignmentRequestTag
                  status={'assignedToMe'}
                  scope={'registry'}
                  showIcon
                  name={request.stateReqById.data?.registryUser?.username}
                />
              ) : (
                <AssignmentRequestTag
                  showIcon
                  scope={'registry'}
                  status={isRegistryAssigned ? 'assignedTo' : undefined}
                  name={request.stateReqById.data?.registryUser?.username}
                />
              )}
            </Space>
          )}
        </Space>
      </div>
      <div style={{ float: 'right' }}>
        <AssignmentRequestActions
          requestId={request.id}
          onSuccess={request.reload}
          disableAssignToUserButton={_disableAssignToUserButton}
          disableAssignToMeButton={_disableAssignToMeButton}
          disableReleaseButton={_disableReleaseButton}
          flash={true}
          showAsPrimary={true}
        />
      </div>
    </HorizontalLayout>
  )
}
